import type {ConsentMode, IConsentTemplate} from "../types";

/**
 * CBK trzyma treści zgód w dwóch formach: jako samodzielne zdanie ("Wyrażam zgodę na…")
 * albo jako dopełnienie zdania ("oznacza zgodę na…"). Drugi wariant wymaga prefiksu
 * dobranego do sposobu wyrażenia zgody — kliknięcia w checkbox albo samej wysyłki formularza.
 */
const consentContentPrefixes: Record<ConsentMode, string> = {
    default: "Wysyłając ten formularz",
    optional: "Zaznaczając to pole",
    required: "Zaznaczając to pole"
};

const isSentenceContinuation = (content: string) => /^\p{Ll}/u.test(content);

export const getConsentContent = (template: IConsentTemplate): string =>
    isSentenceContinuation(template.content) ? `${consentContentPrefixes[template.consent_mode]} ${template.content}` : template.content;
import type {ConsentMode, IConsentTemplate} from "../types";

/**
 * CBK trzyma treści zgód w dwóch formach: jako samodzielne zdanie ("Wyrażam zgodę na…")
 * albo jako dopełnienie zdania ("oznacza zgodę na…"). Drugi wariant wymaga prefiksu
 * dobranego do sposobu wyrażenia zgody — kliknięcia w checkbox albo samej wysyłki formularza.
 */
const consentContentPrefixes: Record<ConsentMode, string> = {
    default: "Wysyłając ten formularz",
    optional: "Zaznaczając to pole",
    required: "Zaznaczając to pole"
};

const isSentenceContinuation = (content: string) => /^\p{Ll}/u.test(content);

export const getConsentContent = (template: IConsentTemplate): string =>
    isSentenceContinuation(template.content) ? `${consentContentPrefixes[template.consent_mode]} ${template.content}` : template.content;
